<template>
	<div class="p-col-12 p-grid">
		<div class="p-col-12 p-lg-6" :class="[commonService.isMobile() ? 'text-box-mobile' : 'text-box']">
			<p>For the Agent</p>
			<p class="login-subtitle">Start to get proposals from the European Leagues</p>
			<p class="login-text justified">Registering as a football player on our platform only requires 3 simple steps, but they are essential to ensure our algorithm generates the best offers for you. </p>
			<p class="login-text justified">Add your football experience and personal information for accurate representation on the market. Carefully evaluate offers and use the negotiation function for a favorable final agreement.</p>
			<div v-if="!commonService.isMobile()" class="p-lg-3 button-box" style="padding: 0px">
				<Button label="Sign up now" class="p-button-warning" style="color: white; font-weight: bold;" @click="toLogin" />
			</div>
		</div>
		<div class="p-col-12 p-lg-6" style="margin: auto">
			<div class="card card-w-title" style="width: 100%;">
				<Toast />
				<div class="p-grid">
					<img :src="commonService.getHomeContractImageUrl()" alt="" style="width: 100%">
				</div>
			</div>
			<div v-if="commonService.isMobile()" class="p-col-4 button-box-mobile" style="margin-top: -30px; margin-bottom: 30px">
				<Button label="Sign up now" class="p-button-warning" style="color: white; font-weight: bold;" @click="toLogin" />
			</div>
		</div>
	</div>
</template>

<script>
import CommonService from "@/service/CommonService";

export default {
	commonService: null,
	created() {
		this.commonService = new CommonService();
	},
	methods: {
		toLogin() {
			this.$router.push("/login");
		},
	},
};
</script>

<style scoped>
.justified {
	text-align: justify;
	text-justify: inter-word;
}

.login-title {
	margin-top: -15px;
	font-size: 65px;
	font-weight: bold;
}

.login-subtitle {
	margin-top: -10px;
	font-size: xx-large;
	font-weight: bold;
}

.login-text {
	margin-top: 10px;
	font-size: 19px;
}

.text-box {
	margin: auto;
	padding-left: 50px;
}

.text-box-mobile {
	margin: auto;
}

.button-box {
	margin-top: 20px;
}

.button-box-mobile {
	margin: auto;
}

@media (min-width: 0px) and (max-width: 1000px) {
	.login-title {
		margin-top: -15px;
		font-size: 45px;
		font-weight: bold;
	}

	.login-subtitle {
		margin-top: -0px;
		font-size: x-large;
		font-weight: bold;
    }

	.login-text {
		margin-top: 10px;
		font-size: 16px;
	}
}
</style>